import * as React from "react"
import { useCurrentUser } from "context/api"
import { RoleTypes } from "util/constants"

// used to lock down components based on their role:
// ADMIN or MEMBER

export function hasPermission({
  role,
  allowedRoles,
}: {
  role: RoleTypes
  allowedRoles: RoleTypes[]
}): boolean {
  return allowedRoles.some(allowedRole => role === allowedRole)
}

export default function PermissionsGate({
  children,
  allowedRoles = [],
}: {
  children: React.ReactNode
  allowedRoles: RoleTypes[]
}) {
  const { data } = useCurrentUser()
  const permissionGranted = hasPermission({ role: data?.type, allowedRoles })

  if (!permissionGranted) return <></>

  return <>{children}</>
}
